module.exports = __webpack_public_path__ + "img/PDF.068d96a3.png";